import { addEventEntry, addDataLayerEntry } from '@printdeal/data-layer-manager';

enum OrderOverviewCategories {
  ORDER_OVERVIEW = 'order_overview',
}

enum OrderOverviewEvents {
  ORDER_OVERVIEW_INTERACTION = 'order_overview',
}

export const dispatchDataLayerOrderOverviewInteraction = (
  action: string,
  extraData: { [key:string] : any } | undefined = undefined,
) => {
  // GA4
  addDataLayerEntry(OrderOverviewEvents.ORDER_OVERVIEW_INTERACTION, {
    action,
    ...(extraData), // optional spreading
  });

  // GA3
  addEventEntry({
    eventCategory: OrderOverviewCategories.ORDER_OVERVIEW,
    eventAction: action,
    eventLabel: extraData && JSON.stringify(extraData),
  });
};

export const dispatchDataLayerOrderSearch = (
  searchQuery: string,
  countResults: number,
  currentPage: number | null,
  searchFilter: string,
) => {
  // GA4
  addDataLayerEntry(OrderOverviewEvents.ORDER_OVERVIEW_INTERACTION, {
    action: 'order_search',
    search_query: searchQuery,
    search_filter: searchFilter,
    search_page: currentPage,
    search_results: countResults,
  });

  // GA3
  addEventEntry({
    eventCategory: OrderOverviewCategories.ORDER_OVERVIEW,
    eventAction: 'order_search',
    eventLabel: `results: ${countResults}, query: ${searchQuery}, filter: ${searchFilter}, page: ${currentPage}`,
    eventNonInteraction: true,
  });
};
